import { useFiltrosGlobales } from '@/lib/FiltrosGlobalesContext';
import { cliente } from '@/lib/cliente';
import type { PeriodoMaqSel } from '@/lib/cliente';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

/**
 * Trae TODAS las filas de Maquinaria Detallada que matcheen los filtros
 * (sin paginar) para la tabla con filtro/orden por columna estilo Excel —
 * necesita ver los valores distintos de cada columna en todo el dataset, no
 * solo la página visible. El propio componente pagina en el cliente.
 */
export function useMaquinariaDetalleTodo(periodoMaq?: PeriodoMaqSel) {
  const { filtros } = useFiltrosGlobales();

  return useQuery({
    queryKey: ['maquinaria-detalle-todo', filtros, periodoMaq],
    queryFn: () => cliente.maquinaria.detalleTodo(filtros, periodoMaq),
    placeholderData: keepPreviousData,
  });
}
